<script lang="ts">
	import { type SnapshotRawData } from "luxedo-data"
	import { LuxedoRPC } from "luxedo-rpc"
	import SnapshotInstance from "./SnapshotInstance.svelte"
	import Header from "../../reusable/Header.svelte"
	import { saveAs } from "file-saver"

	let pageAmount = $state(0)
	let pageNumber = $state(0)

	let isLoading = $state(true)
	let isDownloading = $state(false)

	let selectedSnapshotIds: { [index: number]: boolean } = $state([])
	let snapshots: Array<SnapshotRawData> = $state([])

	let selectedAmount = $derived(Object.keys(selectedSnapshotIds).length)

	async function updateSnapshotList(pageNumber: number) {
		isLoading = true

		const res = await LuxedoRPC.api.admin.get_snapshots_by_page(pageNumber)

		pageAmount = res.total
		snapshots = res.data

		isLoading = false
	}

	$inspect(snapshots)

	function navigatePage(goBack: boolean) {
		if (goBack) pageNumber--
		else pageNumber++

		if (pageNumber >= pageAmount) pageNumber = 0
		if (pageNumber < 0) pageNumber = pageAmount - 1
	}

	function selectSnapshot(id: number, doSelect: boolean) {
		if (doSelect) selectedSnapshotIds[id] = true
		else delete selectedSnapshotIds[id]
	}

	async function download() {
		isDownloading = true
		const ids = Object.keys(selectedSnapshotIds).map(Number)

		const response = await fetch(`${import.meta.env.VITE_API_URL}/workspace/snapshots/download`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			credentials: "include",
			body: JSON.stringify({ ids }),
		})

		if (!response.ok) {
			console.error("Download failed:", response.status)
			return
		}

		const blob = await response.blob()
		saveAs(blob, "snapshots.zip")

		selectedSnapshotIds = {}
		isDownloading = false
	}

	$effect(() => {
		updateSnapshotList(pageNumber)
	})
</script>

<Header heading="Snapshot selector" onNavigate={navigatePage} {pageAmount} bind:pageNumber />
<div class="snapshot-select">
	<div class="snapshots">
		{#each snapshots as snapshot}
			<SnapshotInstance
				{snapshot}
				onSelectToggle={(doSel) => selectSnapshot(snapshot.id, doSel)}
				isSelected={snapshot.id in selectedSnapshotIds}
			/>
		{/each}
	</div>
	<div class="selected-amount-container">
		<span class="selected-text">
			Selected {selectedAmount}
		</span>

		<button class="small" disabled={selectedAmount == 0 || isDownloading} onclick={download}
			>Download{isDownloading ? "ing..." : ""}
		</button>
	</div>
</div>

<style>
	.snapshot-select {
		background-color: var(--color-bg-darker);
		flex-grow: 1;
		display: flex;
		flex-direction: column;
		overflow-x: hidden;
		padding-bottom: 4rem;
	}

	.selected-amount-container {
		color: var(--color-text-light);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		position: fixed;
		bottom: 0rem;
		left: 0rem;
		background-color: var(--color-bg-dark);
		gap: 1rem;
		padding: 0.25rem 0.5rem;
		border-top-right-radius: var(--br);
	}

	.snapshots {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: 1rem; /* Optional: adds spacing between snapshots */
		padding: 1rem;
	}
</style>
